export default "__VITE_ASSET__80ea0278__"